export default __webpack_public_path__ + "static/media/keep-booking-mobile.7305f305.png";